import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { getSubtitleKeyOfTridy,getTitleKeyOfTridy } from 'na-lib';
import { SettingsService } from 'src/app/service/settings.service';

@Component({
    selector: 'app-tridy-icoming-outgoing-data-card',
    templateUrl: './tridy-icoming-outgoing-data-card.component.html',
    styleUrl: './tridy-icoming-outgoing-data-card.component.css',
    standalone: false
})
export class TridyIcomingOutgoingDataCardComponent {
  @Input() type:string;
  @Input() data: any
  @Input() allTridysList:any
  @Input() allContentTypesList:any
  contextId:string

  constructor(private router:Router,
    private settingsService: SettingsService){}

  ngOnInit(): void { 
    this.contextId = this.settingsService.contextId$;
   }

  ngOnChanges(){     
  }

  getContentTypeFieldById(id, field){
    const content =  this.allContentTypesList?.find( ct => ct.id == id)
    if(content && content[field]){
      return content[field]
    }
  }

  getTRIDYIdData(tridyId, field){
    if(this.allTridysList){
      const tridy = this.allTridysList?.find( id => tridyId == id.id)
      if(tridy && tridy[field]){
        return tridy[field]
      }
    }
  }

  getTitleKeyOfTridy(data, titleKey){
    return getTitleKeyOfTridy(data, titleKey)
  }

  getSubtitleKeyOfTridy(data, subtitleKeys){
    return getSubtitleKeyOfTridy(data, subtitleKeys)
  } 

  openDetailedView(tridyId?:string) {
    if (tridyId) {
        const url = this.router.serializeUrl(
        this.router.createUrlTree(['home', this.contextId, 'tridys', tridyId])
      );
      window.open(url, '_blank');
    }
    else {
      const url = this.router.serializeUrl(
        this.router.createUrlTree(['home', this.contextId, 'tridys', this.data.idToShow])
      );
      window.open(url, '_blank');
    }

  }

}
